import { Routes } from "app/routes"
import { GracefulErrorDisplay } from "app/core/components/error-handlers/GracefulErrorDisplay"
import React from "react"
import { useRouter } from "next/router"

// we don't want to confuse the user with CSRF error messages,
// so just say the session has expired, reset session on server and client (!)
// and redirect to login
export const CSRFErrorDisplay = () => {
  const router = useRouter()
  return (
    <GracefulErrorDisplay
      icon={
        <span className="text-danger fs-1">
          <i className="bi bi-hourglass-bottom me-2"></i>
        </span>
      }
      title={"Your session has expired."}
      fullHeight={true}
      link={
        <button
          className="btn btn-outline-dark m-2"
          onClick={async () => {
            await fetch(process.env.NEXT_PUBLIC_APP_ORIGIN + "/api/auth/reset-session")
            await router.push(Routes.LoginPage())
          }}
        >
          <span className="d-flex align-items-center">
            <i className="bi bi-box-arrow-in-right fs-5 me-2" />
            Log in
          </span>
        </button>
      }
    />
  )
}
